// Polyfills for Node.js globals in browser environment
import { Buffer } from 'buffer';

// Make Buffer available globally
(window as any).Buffer = Buffer;

// Make global available (though we also define it in vite.config.ts)
(window as any).global = window;